import React from "react";
import ReactDOM from "react-dom";

export default class Opinii extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      topic: "",
      nume_prenume: "",
      email: "",
      nr_telefon: "",
      description: ""
    };
  }

  handleInputChange = event => {
    this.setState({ [event.target.name]: event.target.value });
  };

  render() {
    return (
      <>
        <div className="col">
          <form action="" method="POST" encType="multipart/form-data" className="mb-4">
            <div className="b-shadow top-b p-5">
              <div className="row row-cols-lg-2 row-cols-md-2 row-cols-sm-2 row-cols-1">
                <div className="col mb-2">
                  <label htmlFor="topic">Exprimați-vă părerea</label>
                  <select
                    name="topic"
                    className="form-control"
                    id="topic"
                    value={this.state.topic}
                    onChange={this.handleInputChange}
                  >
                    <option>Despre site</option>
                    <option>Despre activitatea Direcției Poliția Locală Timișoara</option>
                  </select>
                </div>
                <div className="col mb-2">
                  <label htmlFor="nume">
                    Nume și Prenume <sup className="text-danger">*</sup>
                  </label>
                  <input
                    name="nume_prenume"
                    type="text"
                    className="form-control"
                    id="nume"
                    onChange={this.handleInputChange}
                    value={this.state.nume_prenume}
                    required
                  />
                </div>
              </div>

              <div className="row row-cols-lg-2 row-cols-md-2 row-cols-sm-2 row-cols-1">
                <div className="col mb-2">
                  <label htmlFor="email">
                    Adresă Email <sup className="text-danger">*</sup>
                  </label>
                  <input
                    name="email"
                    type="email"
                    className="form-control"
                    id="email"
                    aria-describedby="emailHelp"
                    onChange={this.handleInputChange}
                    value={this.state.email}
                    required
                  />
                </div>
                <div className="col mb-2">
                  <label htmlFor="nr_telefon">
                    Telefon <sup className="text-danger">*</sup>
                  </label>
                  <input
                    name="nr_telefon"
                    type="text"
                    className="form-control"
                    id="nr_telefon"
                    aria-describedby="nr_telefon"
                    maxLength="10"
                    onChange={this.handleInputChange}
                    value={this.state.nr_telefon}
                    required
                  />
                </div>
              </div>

              <div className="form-group">
                <label htmlFor="opinie">
                  Opinia dumneavoastră <sup className="text-danger">*</sup>
                </label>
                <textarea
                  name="description"
                  className="form-control"
                  id="opinie"
                  rows="5"
                  onChange={this.handleInputChange}
                  value={this.state.description}
                  required
                ></textarea>
              </div>

              <button name="send" type="submit" className="btn btn-lg btn-primary px-md-5 px-sm-4 px-4">
                <small>Trimite</small>
              </button>
            </div>
          </form>
        </div>
      </>
    );
  }
}

if (document.getElementById("feedback")) ReactDOM.render(<Opinii />, document.getElementById("feedback"));
